<template>
  <div class="min-h-screen flex items-start justify-center bg-white relative">
    <div class="w-full max-w-md px-8 slide-up">
      <div class="flex justify-center mt-4">
        <router-link to="/">
          <img src="../assets/logo-primary.png" alt="IMF Logo" class="h-auto w-72 transition-transform duration-300 hover:scale-105" />
        </router-link>
      </div>
      <div class="relative bottom-6">
        <h1 class="text-2xl font-extrabold text-center text-zinc-800 mb-4">Welcome to <span class="text-orange-600">Registration</span></h1>
        <p class="text-center text-gray-500 mb-6">Verification may take up to 24 hours after registration.</p>

        <form class="space-y-3" @submit.prevent="handleSubmit()">
          <div class="relative">
            <input
              type="text"
              v-model.trim="firstname"
              placeholder=""
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              First Name
            </label>
          </div>

          <div class="relative">
            <input
              type="text"
              v-model.trim="lastname"
              placeholder=""
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Last Name
            </label>
          </div>

          <div class="relative">
            <input
              type="email"
              v-model.trim="email"
              placeholder=" "
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Email Address
            </label>
          </div>

          <div class="relative">
            <input
              type="text"
              v-model.trim="contactnumber"
              placeholder=" "
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Contact Number
            </label>
          </div>
          <div class="relative" v-if="true">
            <select
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 appearance-none focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
              v-model="selectedYear"
              id="year"
            >
              <option value="" disabled selected>--Select Year--</option>
              <option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Year of Birth
            </label>
          </div>
          <div class="relative">
            <input
              type="text"
              v-model.trim="iwccardno"
              class="uppercase peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              IWC Card Number
            </label>
          </div>

          <!-- Circle Avatar Upload -->
          <div class="relative">
            <label
              for="file-upload"
              class="flex items-center justify-center w-32 h-32 rounded-full border-2 border-dashed border-gray-300 cursor-pointer hover:border-orange-400 overflow-hidden bg-gray-50 mx-auto"
            >
              <div v-if="!selectedImage" class="flex flex-col items-center justify-center text-center">
                <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0l-3 3m3-3l3 3M17 8v8a4 4 0 01-4 4H7a4 4 0 01-4-4V8a4 4 0 014-4h3" />
                </svg>
                <p class="text-xs text-gray-500 mt-1">Upload your Profile Photo</p>
              </div>

              <img v-else :src="selectedImage" alt="Preview" class="w-full h-full object-cover" />
            </label>

            <input id="file-upload" type="file" accept="image/*" class="hidden" required @change="handleImageUpload" />

            <p class="text-xs text-gray-500 text-center mt-2">PNG, JPG up to 15MB</p>
          </div>
          <!-- End Avatar Upload -->

          <div class="flex gap-4 items-start">
            <input type="checkbox" class="scale-125 mt-1" required />
            <div class="text-sm text-zinc-600">
              I understand that my health records from this teleconsultation will be stored and retained in line with applicable Philippine regulations and the data controller’s
              policy.
              <a @click="modalConsent()" class="text-blue-600 underline">Learn more</a>
            </div>
          </div>
          <div class="flex gap-4 items-start">
            <input type="checkbox" class="scale-125 mt-1" required />
            <div class="text-sm text-zinc-600">
              I agree to the
              <a @click="modalTermAndCondition()" class="text-blue-600 underline">Terms and Condition</a>
              and understand that non-compliance may result in restricted access to the service
            </div>
          </div>

          <div class="pt-4">
            <button
              type="submit"
              :disabled="isSubmitting"
              class="w-full py-3 bg-primary hover:bg-hover text-white font-semibold rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              <svg v-if="isSubmitting" class="w-5 h-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z" />
              </svg>
              <span>{{ isSubmitting ? "Registering..." : "Register" }}</span>
            </button>
          </div>
        </form>

        <div class="mt-6 text-center text-sm text-gray-600">
          Already have an account?
          <router-link to="/portal/login" class="text-orange-500 hover:underline"> Sign in here </router-link>
        </div>
      </div>
      <div class="text-center text-xs text-zinc-500 pb-4">Version 1.0.0</div>
    </div>
  </div>
</template>

<script>
import { ref, inject, reactive, toRefs, computed } from "vue";
import { useRouter } from "vue-router";
import systemVersion from "@/utils/version";

export default {
  setup() {
    const axios = inject("$axios");
    const Swal = inject("$swal");
    const router = useRouter();
    const selectedYear = ref("");

    const selectedImage = ref(null);
    const selectedFile = ref(null);
    const isSubmitting = ref(false);
    const { appVersion } = systemVersion();

    const formDetails = reactive({
      controlNumber: "",
      firstname: "",
      lastname: "",
      email: "",
      contactnumber: "",
      birthyear: "",
      iwccardno: "",
    });

    const handleImageUpload = (event) => {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        if (file.size <= 15 * 1024 * 1024) {
          selectedFile.value = file;
          selectedImage.value = URL.createObjectURL(file);
        } else {
          Swal.fire("Too Large", "Image must be under 15MB.", "warning");
        }
      } else {
        selectedFile.value = null;
        selectedImage.value = null;
      }
    };

    const handleSubmit = async () => {
      if (isSubmitting.value) return;
      isSubmitting.value = true;
      formDetails.birthyear = selectedYear.value;

      try {
        const formData = new FormData();

        for (const key in formDetails) {
          formData.append(key, formDetails[key]);
        }

        if (selectedFile.value) {
          formData.append("file", selectedFile.value);
        } else {
          Swal.fire("No photo", "Please upload your profile photo.", "warning");
          isSubmitting.value = false;
          return;
        }

        let result = await axios.post("/api/patient/registration", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        const isFailed = result.data.status;

        if (!isFailed) {
          Swal.fire({
            icon: "warning",
            title: "Registration Failed",
            text: `The card number you entered is already registered. Please verify your information`,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "🎉 You're Almost In!",
            text: `Thanks for registering! We’re reviewing your information, and once the process is complete, we’ll send your Control Number to your email at ${formDetails.email}.`,
          }).then(() => router.push("/portal/login"));
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text: error.response?.data?.message || "Something went wrong.",
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    const years = computed(() => {
      const startYear = 1960;
      const endYear = 2020;
      const arr = [];
      for (let y = endYear; y >= startYear; y--) {
        arr.push(y);
      }
      return arr;
    });

    const modalConsent = () => {
      Swal.fire({
        icon: "info",
        title: "Telemedicine Consultation Consent",
        html: `
  <div style="max-height: 400px; overflow-y: auto; text-align: justify; padding-right: 10px; font-size: 14px; line-height: 1.6;">
  <p><b>1. Introduction & Nature of Teleconsultation</b></p>
  <ul style="list-style-type: disc; margin-left: 20px;">
    <li>Teleconsultation involves the use of electronic devices (e.g., computer, smartphone) to communicate with a licensed physician for purposes of diagnosis, treatment, follow-up, and/or education.</li>
    <li>The teleconsultation may involve live two-way audio and video, sharing of medical images, medical records, or other relevant health data.</li>
    <li>This method of consultation may not be appropriate for all medical conditions, especially those requiring a physical examination.</li>
  </ul>
<br/>
  <p><b>2. Confidentiality and Privacy</b></p>
  <ul style="list-style-type: disc; margin-left: 20px;">
    <li>My personal health information will be treated confidentially.</li>
    <li>The teleconsultation system will use security measures (network/software) to protect my identity, data integrity, and privacy.</li>
    <li>The processing of my personal and health data (sensitive personal information) will comply with the Data Privacy Act of 2012 (RA 10173).</li>
    <li>I have the right to know how my data will be used, stored, shared, and for how long; and whom to contact about my data privacy concerns (e.g., the Data Protection Officer).</li>
  </ul>

<br/>
  <p><b>3. Risks & Limitations</b></p>
  <ul style="list-style-type: disc; margin-left: 20px;">
    <li>There is a risk of technology failure (poor internet connection, software issues) that could interrupt or degrade the quality of the consultation.</li>
    <li>There is a risk, though minimized, of a breach in confidentiality despite security measures.</li>
    <li>Teleconsultation might not be sufficient for certain medical problems; I may need to have an in-person visit if required.</li>
  </ul>

<br/>
  <p><b>4. Right to Refuse or Discontinue</b></p>
  <ul style="list-style-type: disc; margin-left: 20px;">
    <li>I have the right to refuse or withdraw my consent at any time during or before the teleconsultation.</li>
    <li>Refusing or stopping the teleconsultation will not affect my right to future in-person consultations or medical care.</li>
  </ul>

<br/>
  <p><b>5. Identification & Verification</b></p>
  <ul style="list-style-type: disc; margin-left: 20px;">
    <li>I confirm that I am within the territorial jurisdiction of the Philippines, and that the physician I will consult with is licensed to practice in the Philippines.</li>
    <li>Both the patient and the physician will verify their identities at the start of the teleconsultation.</li>
  </ul>

<br/>
  <p><b>6. Records and Documentation</b></p>
  <ul style="list-style-type: disc; margin-left: 20px;">
    <li>A clinical summary, prescription (if applicable), or referral may be sent via electronic means (e.g., email) in a format acceptable under Philippine law (e.g., Electronic Commerce Act).</li>
    <li>I have the right to request a copy of the electronic clinical summary or medical records generated during the teleconsultation.</li>
  </ul>

<br/>

<br/>
  <p>Please read carefully before proceeding. By clicking “I Understand,” you confirm that you have understood and accepted these terms.</p>
</div>

  `,
        confirmButtonText: "I Undestand",
        confirmButtonColor: "#f59e0b",
        width: 600,
        scrollbarPadding: false,
      });
    };

    const modalTermAndCondition = () => {
      Swal.fire({
        icon: "info",
        title: "Terms and Conditions",
        html: `
<div style="max-height: 400px; overflow-y: auto; text-align: justify; padding-right: 10px; font-size: 14px; line-height: 1.6;">

<p><b>ACCEPTANCE OF TERMS</b></p>
<p>By accessing or using the Interfaced Medical Facilities, Inc. platform (“Platform”), including its website, mobile app, messaging tools, and teleconsultation services (“Services”), you agree to be bound by these Terms and Conditions.</p>
<p>If you do not agree to these Terms, you must not use the Platform.</p>

<br/>
<p><b>NATURE OF SERVICES</b></p>
<p>The Platform provides access to licensed Filipino healthcare professionals who may offer:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Online medical consultations</li>
  <li>Health assessments</li>
  <li>Electronic medical advice</li>
  <li>Electronic prescriptions (when applicable)</li>
  <li>Follow-up consultations</li>
  <li>Telemonitoring</li>
</ul>
<p>The Platform itself does not practice medicine. All medical advice is provided solely by independently practicing, PRC-licensed healthcare professionals.</p>

<br/>
<p><b>ELIGIBILITY</b></p>
<p>You must be:</p>
<ol style="margin-left: 20px;">
  <li>At least 18 years old, or represented by a parent/guardian if a minor;</li>
  <li>Capable of giving legal consent;</li>
  <li>Providing true and accurate personal and medical information.</li>
</ol>
<p>False or misleading information may result in termination of access to the Services.</p>

<br/>
<p><b>NO EMERGENCY SERVICES</b></p>
<p>The Platform must not be used for emergencies involving:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Severe difficulty breathing</li>
  <li>Chest pain or suspected heart attack</li>
  <li>Stroke symptoms</li>
  <li>Unresponsiveness</li>
  <li>Severe bleeding</li>
  <li>Any life-threatening condition</li>
</ul>
<p><b>FOR MEDICAL EMERGENCIES, go to the nearest hospital immediately.</b></p>

<br/>
<p><b>USER RESPONSIBILITIES</b></p>
<p>You agree to:</p>
<ol style="margin-left: 20px;">
  <li>Provide accurate personal, health, and contact information.</li>
  <li>Use the Platform only for lawful and legitimate medical consultations.</li>
  <li>Avoid abusive behavior, harassment, or inappropriate conduct toward doctors or staff.</li>
  <li>Maintain the confidentiality of your account credentials.</li>
  <li>Accept that medical outcomes depend on the accuracy of the information you provide.</li>
</ol>

<br/>
<p><b>DOCTOR-PATIENT RELATIONSHIP</b></p>
<p>A doctor-patient relationship is formed only when:</p>
<ol style="margin-left: 20px;">
  <li>You request a consultation, and</li>
  <li>A licensed physician accepts and begins evaluating your case.</li>
</ol>
<p>The relationship ends once the consultation is completed unless continued care is agreed upon.</p>

<br/>
<p><b>LIMITATIONS OF TELEMEDICINE</b></p>
<p>By using the Platform, you acknowledge that teleconsultation:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>May not replace physical examination;</li>
  <li>Has limitations due to video/audio quality or missing clinical data;</li>
  <li>May require in-person consultation for proper diagnosis;</li>
  <li>Cannot guarantee specific outcomes.</li>
</ul>
<p>Doctors may refuse, discontinue, or redirect consultations when clinically appropriate.</p>

<br/>
<p><b>PRESCRIPTIONS AND MEDICATIONS</b></p>
<p>Doctors may issue electronic prescriptions only when allowed under:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>The Medical Act</li>
  <li>FDA and DOH guidelines</li>
  <li>PRC regulations</li>
</ul>
<p>Certain drugs (e.g., dangerous drugs, controlled substances) cannot be prescribed through teleconsultation.</p>

<br/>
<p><b>FEES AND PAYMENT</b></p>
<p>Consultation fees, subscriptions, or service charges will be shown at the time of booking. You agree that:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Fees will be charged to your out-patient benefit (for those who are using HMO card)</li>
  <li>Fees are non-refundable except where required by law</li>
  <li>Platform charges may change without prior notice</li>
</ul>
<p>The Platform may use third-party payment processors.</p>

<br/>
<p><b>DATA PRIVACY & SECURITY (RA 10173)</b></p>
<p>We comply with the Data Privacy Act of 2012 and NPC regulations. We collect personal and medical information for:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Providing teleconsult services</li>
  <li>Maintaining medical records</li>
  <li>Improving platform performance</li>
  <li>Complying with legal obligations</li>
</ul>
<p>You consent to the collection, processing, and storage of your data.</p>
<p>Data Security Measures Include:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Encrypted communication</li>
  <li>Secure EMR storage</li>
  <li>Access control and logging</li>
  <li>Regular security audits</li>
  <li>Confidentiality agreements with staff</li>
</ul>
<p>Your personal information will not be sold, rented, or used for advertising without explicit consent. For full details, see the Privacy Policy.</p>

<br/>
<p><b>PATIENT RECORDS & RETENTION</b></p>
<p>Medical records are stored in compliance with:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>DOH EMR Guidelines</li>
  <li>National Privacy Commission (NPC) rules</li>
  <li>Applicable retention periods (usually 5 years minimum)</li>
</ul>
<p>You may request access to your records in writing.</p>

<br/>
<p><b>USER CONTENT & CONDUCT</b></p>
<p>Users must not upload:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>False medical documents</li>
  <li>Offensive or obscene content</li>
  <li>Copyright-infringing materials</li>
  <li>Harmful software or malware</li>
</ul>
<p>Violation may result in suspension or permanent bans.</p>

<br/>
<p><b>PLATFORM AVAILABILITY</b></p>
<p>We make reasonable efforts to keep the Platform available. However, we do not guarantee uninterrupted service due to:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>System maintenance</li>
  <li>Technical issues</li>
  <li>Internet/provider outages</li>
  <li>Force majeure events</li>
</ul>

<br/>
<p><b>LIMITATION OF LIABILITY</b></p>
<p>Interfaced Medical Facilities, Inc. is not liable for:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Errors resulting from inaccurate information provided by users</li>
  <li>Losses due to internet or device failure</li>
  <li>Professional decisions made by doctors</li>
  <li>Delays or failure of communication</li>
  <li>Non-medical outcomes of consultations</li>
</ul>
<p>To the extent permitted by Philippine law, liability is limited to the amount paid for the service in question.</p>

<br/>
<p><b>INDEMNIFICATION</b></p>
<p>You agree to indemnify and hold harmless the Platform, its officers, employees, and partners from claims arising from:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Misuse of the Services</li>
  <li>Violation of these Terms</li>
  <li>Misrepresentation of information</li>
  <li>Unauthorized use of your account</li>
</ul>

<br/>
<p><b>TERMINATION OF ACCESS</b></p>
<p>We may suspend or terminate your account for:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Violations of these Terms</li>
  <li>Fraudulent or abusive behavior</li>
  <li>Non-payment</li>
  <li>Illegal acts</li>
  <li>Threats or harassment toward medical staff</li>
</ul>

<br/>
<p><b>AMENDMENTS</b></p>
<p>These Terms may be updated from time to time. Continued use of the Platform constitutes acceptance of the revised Terms.</p>

<br/>
<p><b>GOVERNING LAW</b></p>
<p>These Terms shall be governed by the laws of the Republic of the Philippines, including:</p>
<ul style="list-style-type: disc; margin-left: 20px;">
  <li>Revised Corporation Code</li>
  <li>Medical Act of 1959</li>
  <li>Data Privacy Act (RA 10173)</li>
  <li>Consumer Act</li>
  <li>DOH/PRC Telemedicine regulations</li>
</ul>

<br/>
<p><b>CONTACT INFORMATION</b></p>
<p>For concerns, complaints, or clarifications, you may contact:<br/>
Interfaced Medical Facilities, Inc.<br/>
Email: <a href="mailto:contact@interactivemedicalfacilities.com">contact@interactivemedicalfacilities.com</a></p>

<br/>
<p>Please read carefully before proceeding. By clicking “I Agree,” you confirm that you have understood and accepted these terms.</p>

</div>
`,

        confirmButtonText: "I Agree",
        confirmButtonColor: "#f59e0b",
        width: 600,
        scrollbarPadding: false,
      });
    };

    return {
      ...toRefs(formDetails),
      selectedImage,
      handleImageUpload,
      handleSubmit,
      isSubmitting,
      years,
      selectedYear,
      appVersion,
      modalConsent,
      modalTermAndCondition,
    };
  },
};
</script>

<style scoped>
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-up {
  animation: slideUp 0.6s ease-out forwards;
}
</style>
